import React, { useCallback, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { TABLE_TYPES } from "../config/tableConfig";
import { useAuth } from "../../../contexts/AuthContext";
import paths from "../../../routes/paths";
import TableTypeView from "./TableTypeView";
import { getDefaultOnboardTableType } from "../../../utils/getDefaultOnboardTableType";

const isValidTableType = (value) => Object.values(TABLE_TYPES).includes(value);

const TablesContainer = () => {
  const { user, effectiveRoles } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultTableType = getDefaultOnboardTableType(effectiveRoles);

  const tabFromUrl = searchParams.get("tab");
  const tableType = isValidTableType(tabFromUrl)
    ? tabFromUrl
    : defaultTableType;

  useEffect(() => {
    if (!isValidTableType(tabFromUrl)) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("tab", defaultTableType);
      setSearchParams(newParams, { replace: true });
    }
  }, [tabFromUrl]);

  const handleTableTypeChange = useCallback(
    (newTableType) => {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("tab", newTableType);
      setSearchParams(newParams);
    },
    [searchParams, setSearchParams],
  );

  return (
    <Box sx={{ minHeight: isMobile ? "100vh" : "auto", position: "relative" }}>
      {/* <TableToggle
        tableType={tableType}
        onTableTypeChange={handleTableTypeChange}
        isMobile={isMobile}
      /> */}

      <TableTypeView
        key={tableType}
        tableType={tableType}
        isMobile={isMobile}
        user={user}
        navigate={navigate}
        paths={paths}
      />
    </Box>
  );
};

export default TablesContainer;
